import React from "react";
import { awsImageURL } from "../../api/ipconfig";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";

const NewlyCarLunched = ({ item }) => {
  const formatPrice = (price) => {
    if (price >= 100000000000) {
      return (
        (price / 100000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Kharab"
      );
    } else if (price >= 1000000000) {
      return (
        (price / 1000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Arab"
      );
    } else if (price >= 10000000) {
      return (
        (price / 10000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Crore"
      );
    } else if (price >= 100000) {
      return (
        (price / 100000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " lacs"
      );
    } else if (price >= 1000) {
      return (
        (price / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " Thousand"
      );
    } else {
      return price.toLocaleString("en-US", { maximumFractionDigits: 2 });
    }
  };

  return (
    <>
      <Grid
                lg={2.4}
                md={4}
                sm={6}
                className=" col-6 mb-3 p-2 w-100"
                key={`${item?.newcarpost_id}${item?.make}`}
              >
                <Link
                  to={`/new-car-specs?make=${item?.make}/${item?.newcarpost_id}`}
                  key={item?.newcarpost_id}
                >
          <div className="adPost border shadow-sm">
            <div className="position-relative">
              <img
                src={`${awsImageURL}/posts/${item?.newcarpost_token}/${item?.newcarpost_cover}`}
                alt={`${item?.make} ${item?.model_name}`}
                className="p-2"
                onError={(e) => {
                  e.target.src =
                    "https://gallery.famewheels.com/appgallery/no-image.png";
                }}
              />
              <div className="d-flex align-items-center justify-content-between position-absolute top-0 w-100 ">
                <div className="m-0 ribbon2 px-2 py-1 fw-600 featured-badge text-center">
                  Newly Launched
                </div>
              </div>
            </div>

            <div className=" pb-2 px-2 ">
              <div className=" bg-white p-2 rounded-2  ">
                <h5 className="fw-600 ad-Title color-black text-capitalize mb-1">
                  {item?.make} {item?.model_name}
                </h5>
                <h4 className="fw-600 adPrice mt-3">
                  <span>
                    Starting From: PKR {formatPrice(item?.newcarpost_price)}
                  </span>
                </h4>
              </div>
            </div>
          </div>
          </Link>
          </Grid>
       
    </>
  );
};

export default NewlyCarLunched;
